import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_DECENTRALIZATION_SP_LIST_ID");

const expand = "expand=fields(select=id, eNameGroup, eDescriptions, eGroupCode, Members)";

export class DecentralizationGroupsService {
  static async getGroups() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`))
    .then(res => res.data.value && res.data.value.map((o: any) => ({...o.fields})))
    .catch(err => { throw new RequestError(err) });
  }

  static async getGroupOfUser(userId: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`))
    .then(res => res.data.value && res.data.value.map((o: any) => DecentralizationGroupsService.mapData(o))[0].Members.filter((f: any) => f.id === userId))
    .catch(err => { throw new RequestError(err) });
  }

  static async get(id: any) {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&filter=fields/id eq ${id}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        if(res.data.length > 0)
          return DecentralizationGroupsService.mapData(res.data[0]);
        return null;
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async create(fields: any) {
    return api
      .post(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`),
        { fields }
      )
      .then((res) => this.mapData(res.data))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async update(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async delete(id: any, listId?: string) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static mapData(item: any) { 
    return {
      Id: item.fields.id,
      eNameGroup: item.fields.eNameGroup,
      eDescriptions: item.fields.eDescriptions,
      eGroupCode: item.fields.eGroupCode,
      Members: item.fields.Members ? JSON.parse(item?.fields?.Members) : null,
    }
  }
}
